import {betaFirmware} from "../../interfaces/beta-firmware.interface";
import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable, of} from "rxjs";
import {catchError, finalize} from "rxjs/operators";
import {BetaFirmwareService} from "../beta-firmware.service";

export class BetaFirmwareDataSource implements DataSource<betaFirmware> {

	private betaFirmwaresSubject = new BehaviorSubject<betaFirmware[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);
	private countSubject = new BehaviorSubject<number>(0);
	public currentPageCountSubject = new BehaviorSubject<number>(0);

	public loading$ = this.loadingSubject.asObservable();
	public count$ = this.countSubject.asObservable();
	public currentPageCount$ = this.currentPageCountSubject.asObservable();

	constructor(private betaFirmwareService: BetaFirmwareService) {}

	connect(collectionViewer: CollectionViewer): Observable<betaFirmware[]> {
		return this.betaFirmwaresSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.betaFirmwaresSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
		this.currentPageCountSubject.complete();
	}

	list(filters = {}, orderBy = '', order = 'asc',
			 pageNumber = 0, pageSize = 5) {

		this.loadingSubject.next(true);

		this.betaFirmwareService.index(filters, orderBy, order,
			pageNumber, pageSize).pipe(
			catchError(() => of([])),
			finalize(() => this.loadingSubject.next(false))
		)
			.subscribe(response => {
				this.betaFirmwaresSubject.next(response.data);
				this.countSubject.next(response.total);
				this.currentPageCountSubject.next(response.data.length);
			});
	}

	getList() {
		return this.betaFirmwaresSubject.value;
	}
}
